import { SubscriptionType, VariableType } from "@/pages/subscriptions/constants";
import type { SubscriptionV2Variable } from "@/pages/subscriptions/services/types";
import type { SubscriptionPreviewParams } from "../types";

export function buildPreviewParams(
  subscriptionType: SubscriptionType,
  subscriptionName: string,
  metric: string,
  source: string,
  filters: Array<{ dimension: string; value: string[] }> | undefined,
  variables: SubscriptionV2Variable[] | undefined
): SubscriptionPreviewParams {
  if (!metric) {
    return { rule_type: subscriptionType };
  }

  const params: Record<string, unknown> = {};
  const variablesList = variables || [];

  for (const variable of variablesList) {
    if (variable.type === VariableType.AGGREGATION && variable.value) {
      params.aggregation = variable.value;
    } else if (variable.type === VariableType.DATE_RANGE && variable.value) {
      params.date_range = variable.value;
    } else if (variable.type === VariableType.COMPARISON && variable.value) {
      params.threshold_type = variable.value;
    } else if (variable.type === VariableType.CHANGE_TYPE && variable.value) {
      params.comparison_type = variable.value;
    } else if (variable.type === VariableType.THRESHOLD && variable.value) {
      const thresholdValue = String(variable.value);
      const isPercentage = thresholdValue.includes("%");
      const cleanValue = thresholdValue.replace(/[%,]/g, "");
      params.threshold_value = parseFloat(cleanValue) || 0;
      params.is_percentage = isPercentage;
    }
  }

  const metricFilters: Array<{ key: string; value: string[] }> = [];
  if (filters && Array.isArray(filters)) {
    for (const filter of filters) {
      if (filter.dimension && filter.value && filter.value.length > 0) {
        metricFilters.push({
          key: filter.dimension,
          value: filter.value,
        });
      }
    }
  }

  return {
    rule_type: subscriptionType,
    name: subscriptionName || "Preview",
    metric_config: {
      metric_name: metric,
      category: source,
      params,
      filters: metricFilters,
    },
  };
}
